<script>
    import MainCarousel from "../Components/MainCarousel/MainCarousel.svelte";
    import pattern_1 from "../../public/src/svg/Patterns/pattern_1.svelte";
    import pattern_2 from "../../public/src/svg/Patterns/pattern_2.svelte";
    import pattern_3 from "../../public/src/svg/Patterns/pattern_3.svelte";
    import TextArrow from "../Components/TextArrow/TextArrow.svelte";
    import Button from "../Components/Button/Button.svelte";

    let blocks = [
        {
            image: "https://sun9-80.userapi.com/impg/sY8PRKMbZftEvSc4TOQOS4b6VE_SrAanolLPGQ/k2EH08Lc2Rw.jpg?size=1920x1080&quality=96&sign=e02449806dace0527b365f97157cd0d0&type=album",
            text: "Федерация фиджитал-спорта Тюменской области",
            button: "УЗНАТЬ БОЛЬШЕ",
            link: "qaseadss",
        },
        {
            image: "https://sun9-52.userapi.com/impg/Nnz7snpfuxV3li3pjBqcEll3ba8NWaK8anI8KA/J2cPEqi7Ouo.jpg?size=1280x853&quality=96&sign=1d6f1b7b9dd7ffbeb44623a68accc081&type=album",
            text: 'Тюмень - на "Играх Будущего"',
            button: "УЗНАТЬ БОЛЬШЕ",
            link: "eadsfdsf",
        },
        {
            image: "https://sun9-80.userapi.com/impg/sY8PRKMbZftEvSc4TOQOS4b6VE_SrAanolLPGQ/k2EH08Lc2Rw.jpg?size=1920x1080&quality=96&sign=e02449806dace0527b365f97157cd0d0&type=album",
            text: "Федерация фиджитал-спорта Тюменской области",
            button: "УЗНАТЬ БОЛЬШЕ",
            link: "qaseadss",
        },
        {
            image: "https://sun9-52.userapi.com/impg/Nnz7snpfuxV3li3pjBqcEll3ba8NWaK8anI8KA/J2cPEqi7Ouo.jpg?size=1280x853&quality=96&sign=1d6f1b7b9dd7ffbeb44623a68accc081&type=album",
            text: 'Тюмень - на "Играх Будущего"',
            button: "УЗНАТЬ БОЛЬШЕ",
            link: "eadsfdsf",
        },
    ];

    function openLink(link) {
        window.open(link,"_self")
    }
</script>

<div class="site">
    <MainCarousel {blocks} />
    <div class="citation-block">
        <div class="container">
            <div class="citation text-1">
                ФИДЖИТАЛ — это объединение
                <span class="accient-1"> цифровой </span>
                и
                <span class="accient-2"> физической </span>
                активности
            </div>
        </div>
        <div class="pattern-block">
            <div class="pattern">
                <svelte:component this={pattern_1} />
            </div>
        </div>
        <div class="flex end">
            <img class="head-icons" src="/src/head-icons.png" alt="" />
        </div>
        <div class="pattern-block">
            <div class="pattern">
                <svelte:component this={pattern_2} />
            </div>
        </div>
    </div>
    <div id="fps">
        <div class="container">
            <TextArrow id="fps-header" text={"Федерация Фиджитал спорта"} />
            <p class="text-1">
                Это общественная организация, которая отвечает за развитие
                фиджитал-движения и массового спорта в формате
                функционально-цифрового спорта.
            </p>
            <Button
                on:click={() => {
                    openLink("/about");
                }}
                size="42"
            >
                УЗНАТЬ БОЛЬШЕ
            </Button>
        </div>
        <div class="pattern-block flex end">
            <div class="pattern desktop">
                <svelte:component this={pattern_3} />
            </div>
        </div>
    </div>
</div>

<style lang="less" global>
    @import "../styles/main_page.less";
</style>
